import { ResourcesConfig } from 'aws-amplify';
import { AMPLIFY_KEYS } from '../utils/accounts';

const VITE_HOST = import.meta.env.VITE_HOST;
const MODE = import.meta.env.MODE;

const host = MODE.includes('dev') ? 'https://admin.local.aktify.io:3000' : VITE_HOST;

const config = (): ResourcesConfig =>
  localStorage.getItem(AMPLIFY_KEYS.clientId)
    ? {
        Auth: {
          // REQUIRED - Amazon Cognito Region
          Cognito: {
            loginWith: {
              email: true,
              oauth: {
                domain: localStorage.getItem(AMPLIFY_KEYS.cognitoHostedDomain) || '',
                scopes: ['phone', 'email', 'profile', 'openid'],
                redirectSignIn: [`${host}/login/callback`],
                redirectSignOut: [`${host}`],
                responseType: 'code',
              },
            },
            userPoolClientId: localStorage.getItem(AMPLIFY_KEYS.clientId) || '',
            userPoolId: localStorage.getItem(AMPLIFY_KEYS.userPoolId) || '',
            identityPoolId: '',
          },
        },
      }
    : {};

export default config;
